import { render, staticRenderFns } from "./pnr.vue?vue&type=template&id=7850ba0b&"
import script from "./pnr.vue?vue&type=script&lang=js&"
export * from "./pnr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports